import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 14"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.15\" clip-path=\"url(#i-1785742667__a)\"><path d=\"M1.916 7V1.167h11.667V7\"></path><path d=\"M3.666 12.833a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z\" clip-rule=\"evenodd\"></path><path d=\"M11.25 3.5c-4.553 6.203-5.89 8.365-6.346 8.82a1.75 1.75 0 0 1-2.475 0\"></path><path d=\"M11.834 12.833a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z\" clip-rule=\"evenodd\"></path><path d=\"M13.07 12.32a1.75 1.75 0 0 1-2.474 0c-.456-.455-1.793-2.617-6.346-8.82\"></path></g><defs><clipPath id=\"i-1785742667__a\"><path fill=\"#fff\" d=\"M.75 0h14v14h-14z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }